import { achievementActions } from './achievement';
import { notificationsActions } from './notifications';
import { alertActions } from './alert';

export const achievementsSideEffects = [
  achievementActions.getAchievements(),
  notificationsActions.getFloatingNotifications(),
  alertActions.getEffects(),
];
